import { Routes } from '@angular/router';
import { GeaMesLoginComponent, GeaMesCognitoAuthGuard, GeaMesAccessDeniedComponent} from "@gea-mes/cognito"


import {LocationSelectComponent} from "./main/location-select/location-select.component";
import {AreasSelectComponent} from "./main/areas-select/areas-select.component";
import { LogOutPageComponent } from './main/log-out-page/log-out-page.component';
import { ActivitySelectComponent } from './main/activity-select/activity-select.component';
import { PauseComponent } from './pause/pause.component';
import { BreakEarlyComponent } from './break-early/break-early.component';
import { AreaShiftListComponent } from './easy-shift/components/area-shift-list/area-shift-list.component';
import { PriorShiftEditComponent } from './prior-shift-edit/prior-shift-edit.component';

export const routes: Routes = [
  {path: 'login', component: GeaMesLoginComponent},
  {path: 'logout', component: LogOutPageComponent},
  {path: 'accessdenied', component: GeaMesAccessDeniedComponent},
  {
    path: '', canActivate: [GeaMesCognitoAuthGuard],
    children: [ 
      {path: '', redirectTo:'/locations', pathMatch: 'full'},
      {path: 'locations', component: LocationSelectComponent},
      {path: 'area/select/:site/:state/:environment', component: AreasSelectComponent},
      {path: 'area/select/:site', component: AreasSelectComponent},
      {path: 'activity/select/:site', component: ActivitySelectComponent },
      {path: 'pause/:site/:state/:groups/:environment/:lines', component: PauseComponent},
      {path: 'breakearly/:site/:state/:groups/:environment/:lines', component: BreakEarlyComponent},
      {path: 'easyshift/:site/:state/:groups/:environment/:lines', component: AreaShiftListComponent},
      {path: 'manageprevshift/:site/:state/:groups/:environment/:lines', component: PriorShiftEditComponent},
      {path: 'template', loadChildren: () => import('./template/template.module').then(m => m.TemplateModule)}, 
      {path: 'active', loadChildren: () => import('./active-calendar/active-calendar.module').then(m => m.ActiveCalendarModule)},
      {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m=>m.AdminModule)}
    ]
  },
  {path: '**', redirectTo: '/locations'}
];

export const routingComponents = [LocationSelectComponent];
